import React from "react";
import { MdFileDownload } from "react-icons/md";
import { v4 } from "uuid";
import type { AddCardUser } from "../../Users/Users";
import useSourceLogic from "../useSourcesLogic";
import { Dialog } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { CloseSquare } from "iconsax-react";
import { toast } from "react-toastify";
import useToggleModal from "../../../hooks/utils/useToggleModal";

interface IServicesPayload {
  data?: FetchSourcesResponse;
}
function SourcesTab(payload?: IServicesPayload) {
  const { modalState, toggleModalState } = useToggleModal();
  const { handleDownloadSources } = useSourceLogic();
  return (
    <section>
      <div className="">
        <button
          type="button"
          className="btn bg-[#071839] hover:bg-[#4E5566] px-10 text-white"
          onClick={() => toggleModalState()}
        >
          Create Source
        </button>
      </div>
      <div className="bg-white rounded-md p-3 mt-3">
        <div className="card  bg-white  rounded ">
          <div className="flex items-center justify-between">
            <h4 className="text-sm">Manage Sources</h4>
            <div className="flex items-center">
              {/* <label className="input input-sm input-bordered flex items-center gap-2 mr-3">
              <input
                type="text"
                className="grow "
                placeholder="Search by name, email, role"
              />
              <kbd className="kbd kbd-sm">⌘</kbd>
            </label> */}

              <button
                onClick={handleDownloadSources}
                className="btn btn-sm btn-outline"
              >
                <MdFileDownload />{" "}
              </button>
            </div>
          </div>
        </div>

        <div className=" mt-4 bg-white rounded-lg">
          <table className="table">
            <thead className="bg-[#F5F5F5]">
              <tr>
                <th>No</th>
                {/* <th>Id</th> */}
                <th>Name</th>
                <th>Service Code</th>
                <th>Status</th>
                <th>Date Created</th>
              </tr>
            </thead>
            <tbody className="font-xs font-normal">
              {payload?.data?.data?.map((source, index) => (
                <tr className="font-xs font-normal" key={v4()}>
                  <th className="font-xs font-normal">{index + 1}</th>
                  <th className="font-xs font-normal">{source.name}</th>
                  <th className="text-xs font-normal">{source.unique_code}</th>
                  <th className="text-xs font-normal">
                    {source.post_back_url}
                  </th>
                  <th className="text-xs font-normal">
                    {new Date(source.createdAt).toDateString()}
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <AddSourceCard open={modalState} handleClose={toggleModalState} />
      </div>
    </section>
  );
}

export default SourcesTab;

function AddSourceCard(props: AddCardUser) {
  const { createSource, sourceList } = useSourceLogic();
  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <div className="p-6 w-[300px]">
        <div className=" w-full mb-4 flex items-center justify-between">
          <p className="font-bold text-sm">Add New Source</p>
          <button onClick={props.handleClose}>
            <CloseSquare size="22" color="#071839" />
          </button>
        </div>

        <Formik
          initialValues={{
            name: "",
            unique_code: "",
            post_back_url: "",
          }}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            createSource.mutate(values, {
              onSuccess: (response) => {
                toast.dismiss();
                toast.success(`Updates Successfuly`);
                sourceList.refetch();
                props.handleClose();
              },
              onError: () => {
                toast.dismiss();
                toast.error(`Unable to create Source`);
              },
              onSettled: () => {
                setSubmitting(false);
              },
            });
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="">
                <label className="form-control w-full max-w-xs">
                  <p className="label text-xs text-[#4E5566] font-semibold">
                    Name:
                  </p>
                  <Field
                    required
                    name="name"
                    className="input input-bordered outline-none w-full max-w-xs"
                  />
                </label>
              </div>
              <div className="my-4">
                <label className="form-control w-full max-w-xs">
                  <p className="label text-xs text-[#4E5566] font-semibold">
                    Unique Code:
                  </p>
                  <Field
                    required
                    name="unique_code"
                    className="input input-bordered outline-none w-full max-w-xs"
                  />
                </label>
              </div>
              <div className=" mb-3">
                <label className="form-control w-full max-w-xs">
                  <p className="label text-xs text-[#4E5566] font-semibold">
                    Postback Url:
                  </p>
                  <Field
                    required
                    name="post_back_url"
                    className="input input-bordered outline-none w-full max-w-xs"
                  />
                </label>
              </div>
              <div className="mx-6 mt-4">
                <button
                  className="btn btn-outlined w-full bg-[#071839ea] text-white hover:bg-[#071839] "
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Creating User" : "Save"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Dialog>
  );
}
